import React, { useEffect, useState } from 'react';
import maintenance from '../../assets/images/maintenance.svg';
import logo from '../../../static/images/loading-bar-viewnexa.png';
import CountdownTimer from '../../components/CountdownTimer/CountdownTimer';
import { useFlags } from 'launchdarkly-react-client-sdk';

const MaintenanceWindow = () => {
  const UNTIL_IN_MS = 1 * 60000;
  const NOW_IN_MS = new Date().getTime();
  const [untilDateTime, setUntilDateTime] = useState(NOW_IN_MS + UNTIL_IN_MS);
  const [message, setMessage] = useState('The ViewNexa portal is temporarily unavailable for maintenance.\n There will be NO impact on streaming.');

  // const untilDateTime = NOW_IN_MS + UNTIL_IN_MS;
  const flags = useFlags();
  useEffect(() => {
    const uiMaintenanceWindowFlag = flags['UI-enable-maintenance-window'];
    // console.log('uiMaintenanceWindowFlag', uiMaintenanceWindowFlag)
    if (
      uiMaintenanceWindowFlag &&
      uiMaintenanceWindowFlag.message &&
      uiMaintenanceWindowFlag.minutes &&
      typeof uiMaintenanceWindowFlag.minutes === 'number'
    ) {
      // setUntilInMs(1 * uiMaintenanceWindowFlag.minutes);
      const nowInMs = new Date().getTime();
      const ms = uiMaintenanceWindowFlag.minutes * 60000;
      setUntilDateTime(nowInMs + ms);
      setMessage(uiMaintenanceWindowFlag.message);
    }
  }, []);
  return (
    <div className='maintenance-window'>
      <nav className="navabr">
        <div className="navabr-container container">
          <img src={logo} className="logo" />
        </div>
      </nav>
      <section className="maintenance-content">
        <img src={maintenance} alt="maintenance" />
        <div className="text">
          <h1>We’ll be back soon!</h1>
          <pre>{message}</pre>
        </div>
        <div className="countdown">
          <CountdownTimer targetDate={untilDateTime} />
        </div>
      </section>
    </div>
  );
};

export default MaintenanceWindow;
